import { useEffect, useState } from "preact/hooks";
import fetchMonogram from "./fetchMonogram";

/**
 *
 * @param {string} handle monogram_component metaobject handle
 * @returns [data, error] — error is set when the component can't be loaded (a
 *   failed request, or no such metaobject), for callers that need to tell "still
 *   loading" apart from "never arriving".
 */
export default function useMonogram(handle) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!handle) return;

    fetchMonogram(handle)
      .then((component) =>
        component
          ? setData(component)
          : setError(new Error(`No monogram component ${handle}`)),
      )
      .catch(setError);
  }, [handle]);

  return [data, error];
}
